import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SplitContainerAgendaTableRowConverter extends CmsConverterService<SplitContainerAgendaTableRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      textLeft: formData.st_left_column ?? defaultTextInput,
      textRight: formData.st_right_column ?? defaultTextInput,
    }
  }
}

export const SPLIT_CONTAINER_AGENDA_TABLE_ROW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, SplitContainerAgendaTableRowData>>('SplitContainerAgendaTableConverter')

export interface SplitContainerAgendaTableRowData extends ConvertedComponentData {
  textLeft: TextInput;
  textRight: TextInput;
}
